import { inject, Injectable } from '@angular/core';
import { Platform } from '@ionic/angular/standalone';
import { isEmpty } from 'lodash-es';
import { catchError, filter, first, Observable, of, switchMap, tap } from 'rxjs';
import { IMaharahAppConfigsDto } from 'src/app/contracts';
import { Api } from 'src/app/core/common/api';
import { Auth } from 'src/app/core/common/auth';

@Injectable()
export class Configs {
  private platform = inject(Platform);
  private auth = inject(Auth);
  private api = inject(Api);

  configs = {} as IMaharahAppConfigsDto;
  loadConfigs(forceUpdate?: boolean): Observable<IMaharahAppConfigsDto> {
    if (forceUpdate || isEmpty(this.configs)) {
      return this.auth.isReady$.pipe(
        filter(ready => ready),
        first(),
        switchMap(() => this.api.get<IMaharahAppConfigsDto>('configs', { handleError: false })),
        catchError(() => of({} as IMaharahAppConfigsDto)),
        tap(configs => (this.configs = configs || ({} as IMaharahAppConfigsDto))),
        tap(() => this.applyCustomChanges())
      );
    }
    return of(this.configs);
  }
  applyCustomChanges(): void {
    // e.g: this.configs.theme?.useNationalDayTheme ? document.documentElement.classList.add('national-day')
  }
}
